// All 193 UN member states + observer states with dial codes and flag emojis
export const COUNTRY_CODES = [
  { code: '+93', flag: '🇦🇫', name: 'Afganistan' },
  { code: '+355', flag: '🇦🇱', name: 'Arnavutluk' },
  { code: '+213', flag: '🇩🇿', name: 'Cezayir' },
  { code: '+376', flag: '🇦🇩', name: 'Andorra' },
  { code: '+244', flag: '🇦🇴', name: 'Angola' },
  { code: '+1268', flag: '🇦🇬', name: 'Antigua ve Barbuda' },
  { code: '+54', flag: '🇦🇷', name: 'Arjantin' },
  { code: '+374', flag: '🇦🇲', name: 'Ermenistan' },
  { code: '+61', flag: '🇦🇺', name: 'Avustralya' },
  { code: '+43', flag: '🇦🇹', name: 'Avusturya' },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaycan' },
  { code: '+1242', flag: '🇧🇸', name: 'Bahamalar' },
  { code: '+973', flag: '🇧🇭', name: 'Bahreyn' },
  { code: '+880', flag: '🇧🇩', name: 'Bangladeş' },
  { code: '+1246', flag: '🇧🇧', name: 'Barbados' },
  { code: '+375', flag: '🇧🇾', name: 'Belarus' },
  { code: '+32', flag: '🇧🇪', name: 'Belçika' },
  { code: '+501', flag: '🇧🇿', name: 'Belize' },
  { code: '+229', flag: '🇧🇯', name: 'Benin' },
  { code: '+975', flag: '🇧🇹', name: 'Butan' },
  { code: '+591', flag: '🇧🇴', name: 'Bolivya' },
  { code: '+387', flag: '🇧🇦', name: 'Bosna Hersek' },
  { code: '+267', flag: '🇧🇼', name: 'Botsvana' },
  { code: '+55', flag: '🇧🇷', name: 'Brezilya' },
  { code: '+673', flag: '🇧🇳', name: 'Brunei' },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaristan' },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: '+257', flag: '🇧🇮', name: 'Burundi' },
  { code: '+238', flag: '🇨🇻', name: 'Cabo Verde' },
  { code: '+855', flag: '🇰🇭', name: 'Kamboçya' },
  { code: '+237', flag: '🇨🇲', name: 'Kamerun' },
  { code: '+1', flag: '🇨🇦', name: 'Kanada' },
  { code: '+236', flag: '🇨🇫', name: 'Orta Afrika Cumhuriyeti' },
  { code: '+235', flag: '🇹🇩', name: 'Çad' },
  { code: '+56', flag: '🇨🇱', name: 'Şili' },
  { code: '+86', flag: '🇨🇳', name: 'Çin' },
  { code: '+57', flag: '🇨🇴', name: 'Kolombiya' },
  { code: '+269', flag: '🇰🇲', name: 'Komorlar' },
  { code: '+242', flag: '🇨🇬', name: 'Kongo Cumhuriyeti' },
  { code: '+243', flag: '🇨🇩', name: 'Kongo Demokratik Cumhuriyeti' },
  { code: '+506', flag: '🇨🇷', name: 'Kosta Rika' },
  { code: '+225', flag: '🇨🇮', name: 'Fildişi Sahili' },
  { code: '+385', flag: '🇭🇷', name: 'Hırvatistan' },
  { code: '+53', flag: '🇨🇺', name: 'Küba' },
  { code: '+357', flag: '🇨🇾', name: 'Kıbrıs' },
  { code: '+420', flag: '🇨🇿', name: 'Çekya' },
  { code: '+45', flag: '🇩🇰', name: 'Danimarka' },
  { code: '+253', flag: '🇩🇯', name: 'Cibuti' },
  { code: '+1767', flag: '🇩🇲', name: 'Dominika' },
  { code: '+1809', flag: '🇩🇴', name: 'Dominik Cumhuriyeti' },
  { code: '+593', flag: '🇪🇨', name: 'Ekvador' },
  { code: '+20', flag: '🇪🇬', name: 'Mısır' },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador' },
  { code: '+240', flag: '🇬🇶', name: 'Ekvator Ginesi' },
  { code: '+291', flag: '🇪🇷', name: 'Eritre' },
  { code: '+372', flag: '🇪🇪', name: 'Estonya' },
  { code: '+268', flag: '🇸🇿', name: 'Esvatini' },
  { code: '+251', flag: '🇪🇹', name: 'Etiyopya' },
  { code: '+679', flag: '🇫🇯', name: 'Fiji' },
  { code: '+358', flag: '🇫🇮', name: 'Finlandiya' },
  { code: '+33', flag: '🇫🇷', name: 'Fransa' },
  { code: '+241', flag: '🇬🇦', name: 'Gabon' },
  { code: '+220', flag: '🇬🇲', name: 'Gambiya' },
  { code: '+995', flag: '🇬🇪', name: 'Gürcistan' },
  { code: '+49', flag: '🇩🇪', name: 'Almanya' },
  { code: '+233', flag: '🇬🇭', name: 'Gana' },
  { code: '+30', flag: '🇬🇷', name: 'Yunanistan' },
  { code: '+1473', flag: '🇬🇩', name: 'Grenada' },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala' },
  { code: '+224', flag: '🇬🇳', name: 'Gine' },
  { code: '+245', flag: '🇬🇼', name: 'Gine-Bissau' },
  { code: '+592', flag: '🇬🇾', name: 'Guyana' },
  { code: '+509', flag: '🇭🇹', name: 'Haiti' },
  { code: '+504', flag: '🇭🇳', name: 'Honduras' },
  { code: '+36', flag: '🇭🇺', name: 'Macaristan' },
  { code: '+354', flag: '🇮🇸', name: 'İzlanda' },
  { code: '+91', flag: '🇮🇳', name: 'Hindistan' },
  { code: '+62', flag: '🇮🇩', name: 'Endonezya' },
  { code: '+98', flag: '🇮🇷', name: 'İran' },
  { code: '+964', flag: '🇮🇶', name: 'Irak' },
  { code: '+353', flag: '🇮🇪', name: 'İrlanda' },
  { code: '+972', flag: '🇮🇱', name: 'İsrail' },
  { code: '+39', flag: '🇮🇹', name: 'İtalya' },
  { code: '+1876', flag: '🇯🇲', name: 'Jamaika' },
  { code: '+81', flag: '🇯🇵', name: 'Japonya' },
  { code: '+962', flag: '🇯🇴', name: 'Ürdün' },
  { code: '+7', flag: '🇰🇿', name: 'Kazakistan' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya' },
  { code: '+686', flag: '🇰🇮', name: 'Kiribati' },
  { code: '+965', flag: '🇰🇼', name: 'Kuveyt' },
  { code: '+996', flag: '🇰🇬', name: 'Kırgızistan' },
  { code: '+856', flag: '🇱🇦', name: 'Laos' },
  { code: '+371', flag: '🇱🇻', name: 'Letonya' },
  { code: '+961', flag: '🇱🇧', name: 'Lübnan' },
  { code: '+266', flag: '🇱🇸', name: 'Lesoto' },
  { code: '+231', flag: '🇱🇷', name: 'Liberya' },
  { code: '+218', flag: '🇱🇾', name: 'Libya' },
  { code: '+423', flag: '🇱🇮', name: 'Lihtenştayn' },
  { code: '+370', flag: '🇱🇹', name: 'Litvanya' },
  { code: '+352', flag: '🇱🇺', name: 'Lüksemburg' },
  { code: '+261', flag: '🇲🇬', name: 'Madagaskar' },
  { code: '+265', flag: '🇲🇼', name: 'Malavi' },
  { code: '+60', flag: '🇲🇾', name: 'Malezya' },
  { code: '+960', flag: '🇲🇻', name: 'Maldivler' },
  { code: '+223', flag: '🇲🇱', name: 'Mali' },
  { code: '+356', flag: '🇲🇹', name: 'Malta' },
  { code: '+692', flag: '🇲🇭', name: 'Marshall Adaları' },
  { code: '+222', flag: '🇲🇷', name: 'Moritanya' },
  { code: '+230', flag: '🇲🇺', name: 'Mauritius' },
  { code: '+52', flag: '🇲🇽', name: 'Meksika' },
  { code: '+691', flag: '🇫🇲', name: 'Mikronezya' },
  { code: '+373', flag: '🇲🇩', name: 'Moldova' },
  { code: '+377', flag: '🇲🇨', name: 'Monako' },
  { code: '+976', flag: '🇲🇳', name: 'Moğolistan' },
  { code: '+382', flag: '🇲🇪', name: 'Karadağ' },
  { code: '+212', flag: '🇲🇦', name: 'Fas' },
  { code: '+258', flag: '🇲🇿', name: 'Mozambik' },
  { code: '+95', flag: '🇲🇲', name: 'Myanmar' },
  { code: '+264', flag: '🇳🇦', name: 'Namibya' },
  { code: '+674', flag: '🇳🇷', name: 'Nauru' },
  { code: '+977', flag: '🇳🇵', name: 'Nepal' },
  { code: '+31', flag: '🇳🇱', name: 'Hollanda' },
  { code: '+64', flag: '🇳🇿', name: 'Yeni Zelanda' },
  { code: '+505', flag: '🇳🇮', name: 'Nikaragua' },
  { code: '+227', flag: '🇳🇪', name: 'Nijer' },
  { code: '+234', flag: '🇳🇬', name: 'Nijerya' },
  { code: '+850', flag: '🇰🇵', name: 'Kuzey Kore' },
  { code: '+389', flag: '🇲🇰', name: 'Kuzey Makedonya' },
  { code: '+47', flag: '🇳🇴', name: 'Norveç' },
  { code: '+968', flag: '🇴🇲', name: 'Umman' },
  { code: '+92', flag: '🇵🇰', name: 'Pakistan' },
  { code: '+680', flag: '🇵🇼', name: 'Palau' },
  { code: '+507', flag: '🇵🇦', name: 'Panama' },
  { code: '+675', flag: '🇵🇬', name: 'Papua Yeni Gine' },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay' },
  { code: '+51', flag: '🇵🇪', name: 'Peru' },
  { code: '+63', flag: '🇵🇭', name: 'Filipinler' },
  { code: '+48', flag: '🇵🇱', name: 'Polonya' },
  { code: '+351', flag: '🇵🇹', name: 'Portekiz' },
  { code: '+974', flag: '🇶🇦', name: 'Katar' },
  { code: '+82', flag: '🇰🇷', name: 'Güney Kore' },
  { code: '+40', flag: '🇷🇴', name: 'Romanya' },
  { code: '+7', flag: '🇷🇺', name: 'Rusya' },
  { code: '+250', flag: '🇷🇼', name: 'Ruanda' },
  { code: '+1869', flag: '🇰🇳', name: 'Saint Kitts ve Nevis' },
  { code: '+1758', flag: '🇱🇨', name: 'Saint Lucia' },
  { code: '+1784', flag: '🇻🇨', name: 'Saint Vincent ve Grenadinler' },
  { code: '+685', flag: '🇼🇸', name: 'Samoa' },
  { code: '+378', flag: '🇸🇲', name: 'San Marino' },
  { code: '+239', flag: '🇸🇹', name: 'São Tomé ve Príncipe' },
  { code: '+966', flag: '🇸🇦', name: 'Suudi Arabistan' },
  { code: '+221', flag: '🇸🇳', name: 'Senegal' },
  { code: '+381', flag: '🇷🇸', name: 'Sırbistan' },
  { code: '+248', flag: '🇸🇨', name: 'Seyşeller' },
  { code: '+232', flag: '🇸🇱', name: 'Sierra Leone' },
  { code: '+65', flag: '🇸🇬', name: 'Singapur' },
  { code: '+421', flag: '🇸🇰', name: 'Slovakya' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenya' },
  { code: '+677', flag: '🇸🇧', name: 'Solomon Adaları' },
  { code: '+252', flag: '🇸🇴', name: 'Somali' },
  { code: '+27', flag: '🇿🇦', name: 'Güney Afrika' },
  { code: '+211', flag: '🇸🇸', name: 'Güney Sudan' },
  { code: '+34', flag: '🇪🇸', name: 'İspanya' },
  { code: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
  { code: '+249', flag: '🇸🇩', name: 'Sudan' },
  { code: '+597', flag: '🇸🇷', name: 'Surinam' },
  { code: '+46', flag: '🇸🇪', name: 'İsveç' },
  { code: '+41', flag: '🇨🇭', name: 'İsviçre' },
  { code: '+963', flag: '🇸🇾', name: 'Suriye' },
  { code: '+992', flag: '🇹🇯', name: 'Tacikistan' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzanya' },
  { code: '+66', flag: '🇹🇭', name: 'Tayland' },
  { code: '+670', flag: '🇹🇱', name: 'Doğu Timor' },
  { code: '+228', flag: '🇹🇬', name: 'Togo' },
  { code: '+676', flag: '🇹🇴', name: 'Tonga' },
  { code: '+1868', flag: '🇹🇹', name: 'Trinidad ve Tobago' },
  { code: '+216', flag: '🇹🇳', name: 'Tunus' },
  { code: '+90', flag: '🇹🇷', name: 'Türkiye' },
  { code: '+993', flag: '🇹🇲', name: 'Türkmenistan' },
  { code: '+688', flag: '🇹🇻', name: 'Tuvalu' },
  { code: '+256', flag: '🇺🇬', name: 'Uganda' },
  { code: '+380', flag: '🇺🇦', name: 'Ukrayna' },
  { code: '+971', flag: '🇦🇪', name: 'Birleşik Arap Emirlikleri' },
  { code: '+44', flag: '🇬🇧', name: 'Birleşik Krallık' },
  { code: '+1', flag: '🇺🇸', name: 'Amerika Birleşik Devletleri' },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay' },
  { code: '+998', flag: '🇺🇿', name: 'Özbekistan' },
  { code: '+678', flag: '🇻🇺', name: 'Vanuatu' },
  { code: '+58', flag: '🇻🇪', name: 'Venezuela' },
  { code: '+84', flag: '🇻🇳', name: 'Vietnam' },
  { code: '+967', flag: '🇾🇪', name: 'Yemen' },
  { code: '+260', flag: '🇿🇲', name: 'Zambiya' },
  { code: '+263', flag: '🇿🇼', name: 'Zimbabve' },
  // Observer states
  { code: '+39', flag: '🇻🇦', name: 'Vatikan' },
  { code: '+970', flag: '🇵🇸', name: 'Filistin' },
];
